import React from 'react';
import intl from 'react-intl-universal';
import { Box, makeStyles, Typography, Theme } from '@material-ui/core';
import { ReactComponent as LifesizeLogo } from '@lifesize/ux-assets/vectors/svgLogos/lsHorizontal.svg';
import { Button, colors } from '@lifesize/clients.mui-components';
import { useDispatch, useSelector } from 'react-redux';
import { openLoginPage } from 'redux/loginSlice';
import CheckIcon from 'components/CheckIcon';
import { RootState } from 'redux/rootReducer';
import { resetSnackBar } from 'redux/snackBarSlice';
import Alert from '@material-ui/lab/Alert';

const GetStarted = () => {
  const classes = useGetStartedStyles();
  const dispatch = useDispatch();
  const snackBarState = useSelector((state: RootState) => state.snackBar);
  const handleSignIn = () => {
    snackBarState.message && dispatch(resetSnackBar());
    dispatch(openLoginPage());
  };

  return (
    <>
      <Box component="div" className={`${classes.container} ${snackBarState.message && classes.popUpBlocked}`}>
        <Box className={classes.getStarted}>
          {snackBarState.message && (
            <Alert id={'popUpBlockedByUserAlert'} severity="error">
              {intl.getHTML('popUpBlockedByUser')}
            </Alert>
          )}
          <LifesizeLogo className={classes.logo} />
          <Box data-testid="getStartedHeader" textAlign="center" mt={4}>
            <Typography component="div" variant="h3">
              {intl.get('msOutlookAddIn')}
            </Typography>
            <Typography component="span" variant="h3">
              {intl.get('getStartedMessage')}
            </Typography>
          </Box>
          <Box data-testid="getStartedDetails" textAlign="center" my={5}>
            <Typography className={classes.feature} component="div" variant="body1">
              <CheckIcon />
              <Box ml={2} my={1}>
                {intl.get('featureScheduleCalls')}
              </Box>
            </Typography>
            <Typography className={classes.feature} component="div" variant="body1">
              <CheckIcon />
              <Box ml={2} my={1}>
                {intl.get('featureExistingMeetings')}
              </Box>
            </Typography>
            <Typography className={classes.feature} component="div" variant="body1">
              <CheckIcon />
              <Box ml={2} my={1}>
                {intl.get('featureGenerateInvite')}
              </Box>
            </Typography>
          </Box>
          <Button data-testid="signInBtn" color="primary" variant="contained" onClick={handleSignIn}>
            {intl.get('signIn')}
          </Button>
          <Box mt={3} alignSelf="center">
            <Typography component="span" data-testid="signup-link">
              {intl.get('newToLifesize')}
              <Box component={'span'} ml={1}>
                <a
                  className={classes.signUpLink}
                  rel="noopener noreferrer"
                  href="https://signup.lifesize.com"
                  target="_blank"
                >
                  {intl.get('signUp')}
                </a>
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};
const useGetStartedStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px 0 ${theme.spacing(3)}px`,
    width: '100%',
    justifyContent: 'center',
    minHeight: 480
  },
  getStarted: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(14),
    minHeight: 480,
    '& button': {
      alignSelf: 'center'
    }
  },
  logo: {
    color: colors.lifesize,
    width: '60%',
    marginTop: `${theme.spacing(5)}px`,
    alignSelf: 'center',
    minHeight: 80
  },
  signUpLink: {
    color: colors.lifesize,
    cursor: 'pointer',
    margin: `${theme.spacing(3)}px 0`
  },
  feature: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 275,
    margin: '0 auto',
    '& .MuiBox-root': {
      textAlign: 'left'
    }
  },
  popUpBlocked: {
    minHeight: 780
  }
}));
export default GetStarted;
